<template>
  <Header />
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.top">
        <div :class="$style.name">
          <img @click="focus" src="/icons/big-edit.svg" alt="" />
          <div :class="[$style.input, { [$style.error]: errors.name }]">
            <input
              ref="name"
              v-model="name"
              @input="
                $store.commit('setLeadsField', {
                  field: 'name',
                  value: name,
                })
              "
              type="text"
              placeholder="Название проекта"
            />
          </div>
        </div>
        <img
          @click="$router.push('/leads')"
          src="/icons/big-cross.svg"
          alt=""
        />
      </div>
      <Filters for-creation />
      <div :class="$style.form">
        <LeadForm :lead="lead.client" for-creation />
        <div :class="$style.bottom">
          <div v-if="$route.fullPath !== '/new-lead'" :class="$style.author">
            <p>Оформил заявку</p>
            <div>
              {{ lead.author?.name ? lead.author.name : "Данные юзера" }}
            </div>
          </div>
          <div :class="$style.files">
            <File v-for="file in files" :key="file.id" :file="file" />
          </div>
        </div>
        <div
          v-if="lead.notifications && lead.notifications.length"
          :class="$style.notifications"
        >
          <div
            v-for="i in lead.notifications"
            :key="i.id"
            :class="$style.notification"
          >
            <div>
              <img src="/icons/notification-icon.svg" alt="" />
              <div>{{ getTime(i.time_to_notify) }}</div>
              <img
                @click="remove(i.id)"
                src="/icons/cross.svg"
                alt=""
                :class="$style.cross"
              />
            </div>
            <p>{{ i.message }}</p>
          </div>
        </div>
      </div>
      <div :class="$style.buttons">
        <div>
          <div
            :class="[$style.calc, { [$style.error]: errors.estimated_time }]"
          >
            <p>Оценка времени</p>
            <div :class="[$style.time, { [$style.noPadding]: minutes }]">
              <div :class="[$style.input, $style.right]">
                <input v-model="hours" type="number" placeholder="00" />
              </div>
              :
              <div :class="$style.input">
                <input v-model="minutes" type="number" placeholder="00 h" />
              </div>
            </div>
          </div>
          <div
            :class="[$style.calc, { [$style.error]: errors.estimated_cost }]"
          >
            <p>Оценка стоимости</p>
            <div :class="[$style.cost, { [$style.noPadding]: centes }]">
              <div :class="[$style.input, $style.right]">
                <input v-model="dollars" type="number" placeholder="0" />
              </div>
              :
              <div :class="$style.input">
                <input v-model="centes" type="number" placeholder="00 $" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            v-if="$route.fullPath !== '/new-lead'"
            @click="setModal(true)"
            :class="[$style.button, $style.file]"
          >
            Добавить уведомление
          </div>
          <div :class="[$style.button, $style.file]">
            <input @change="setFile($event)" type="file" />
            Добавить файл
          </div>
          <div @click="save" :class="[$style.button, $style.green]">
            Сохранить
          </div>
        </div>
      </div>
    </div>
  </div>
  <NotificationModal
    v-if="isModalOpen"
    @setModal="
      (value) => {
        setModal(value);
      }
    "
  />
</template>

<script>
import Header from "@/components/layouts/Header.vue";
import Filters from "@/components/leads/Filters.vue";
import LeadForm from "@/components/leads/LeadForm.vue";
import NotificationModal from "@/components/modals/NotificationModal";
import File from "@/components/common/File.vue";
export default {
  components: {
    Header,
    Filters,
    LeadForm,
    File,
    NotificationModal,
  },
  data() {
    return {
      hours: "",
      minutes: "",
      dollars: "",
      centes: "",
      name: "",
      errors: [],
      isModalOpen: false,
    };
  },
  async mounted() {
    this.$store.commit("setFiles", null);
    if (this.$route.params.id) {
      await this.$store.dispatch("getLead", this.$route.params.id);
      if (this.lead.estimated_time) {
        this.hours = this.lead.estimated_time.split(".")[0];
        this.minutes = this.lead.estimated_time.split(".")[1];
      }
      if (this.lead.estimated_cost) {
        this.dollars = this.lead.estimated_cost.split(".")[0];
        this.centes = this.lead.estimated_cost.split(".")[1];
      }
      this.name = this.lead.name;
    } else {
      this.$store.commit("resetLead");
    }
  },
  computed: {
    lead() {
      return this.$store.state.leads.lead;
    },
    files() {
      return this.$store.state.attachments.files;
    },
  },
  methods: {
    async save() {
      const time = this.hours + "." + this.minutes;
      const price = this.dollars + "." + this.centes;
      this.$store.commit("setLeadsField", {
        field: "estimated_time",
        value: Number(time),
      });
      this.$store.commit("setLeadsField", {
        field: "estimated_cost",
        value: Number(price),
      });
      let files = [];
      this.files.forEach((i) => files.push(i.id));
      this.$store.commit("setLeadsField", {
        field: "attachments",
        value: files,
      });
      if (this.$route.params.id) {
        const resp = await this.$store.dispatch("updateLead");
        if (!resp) {
          this.errors = this.$store.state.errors.errors[0];
          return;
        }
      } else {
        const resp = await this.$store.dispatch("createLead");
        if (!resp) {
          this.errors = this.$store.state.errors.errors[0];
          return;
        }
      }

      this.$store.commit("resetErrors");
      this.$router.push("/leads");
    },
    focus() {
      this.$refs.name.focus();
    },
    setFile(e) {
      const formData = new FormData();
      formData.set("file", e.target.files[0]);
      this.$store.dispatch("createFile", formData);
    },
    setModal(value) {
      this.isModalOpen = value;
    },
    getTime(time) {
      let temp = time.slice(0, -4).split("T");
      temp[0] = temp[0].split("-").reverse().join(".");
      return temp.join(" ");
    },
    remove(id) {
      this.$store.dispatch("deleteNotification", id);
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  .content {
    background-color: $bg-secondary;
    border-radius: 1rem;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 2rem;
      padding: 1.5rem 1.5rem 0 1.5rem;
      img {
        cursor: pointer;
      }
      .name {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex: 1 1 auto;
        .input {
          width: 100%;
          input {
            width: 100%;
            border: none;
            outline: 0;
            @include H2;
            &::placeholder {
              @include H2;
              color: $t-secondary;
            }
          }
          &.error {
            input {
              &::placeholder {
                color: $red;
              }
            }
          }
        }
      }
    }
    .form {
      padding: 1.5rem;
      background-color: $bg-primary;
      border-top: 1px solid $bg-separator;
      border-bottom: 1px solid $bg-separator;
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 2rem;
        padding: 1.5rem 0 0 0;
        background-color: $bg-primary;
        .author {
          p {
            @include Body3;
            color: $t-secondary;
            margin: 0 0 0.25rem 0;
          }
          div {
            @include Title;
          }
        }
        .files {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
      }
      .notifications {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 1.5rem;
        margin: 1.5rem 0 0 0;
        .notification {
          background-color: $bg-secondary;
          padding: 0.75rem;
          border-radius: 0.25rem;
          > div {
            display: flex;
            align-items: center;
            color: $red-primary;
            gap: 0.5rem;
            margin: 0 0 0.75rem 0;
            position: relative;
            .cross {
              position: absolute;
              top: 0;
              right: 0;
              cursor: pointer;
            }
          }
        }
      }
    }
    .buttons {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      gap: 2rem;
      padding: 1.5rem;
      > div {
        display: flex;
        align-items: center;
        gap: 1rem;
        .button {
          color: $t-secondary;
          padding: 0.75rem 1rem;
          border: 1px solid $t-secondary;
          border-radius: 6.25rem;
          @include ButtonText;
          cursor: pointer;
          &.green {
            color: $t-white;
            background-color: $main-green;
            border: 1px solid $main-green;
          }
          &.file {
            position: relative;

            input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              cursor: pointer;
            }
          }
        }
        .calc {
          p {
            @include Body3;
            color: $t-secondary;
            margin: 0 0 0.25rem 0;
          }
          > div {
            &.time {
              padding: 0.75rem 2.5rem 0.75rem 1.5rem;
            }
            &.cost {
              padding: 0.75rem 3rem 0.75rem 1.5rem;
            }
            &.noPadding {
              padding: 0.75rem 2.5rem;
            }
            border-radius: 0.25rem;
            border: 1px solid $t-secondary;
            color: $t-secondary;
            @include Body1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.25rem;
            .input {
              width: 3rem;
              input {
                width: 100%;
                border: none;
                outline: 0;
                @include Body1;
                &::placeholder {
                  @include Body1;
                  color: $t-secondary;
                }
              }
              &.right {
                input {
                  text-align: right;
                }
              }
            }
          }
          &.error {
            p {
              color: $red;
            }
            > div {
              border: 1px solid $red;
            }
          }
        }
      }
    }
  }
}
</style>
